export default __webpack_public_path__ + "31f694f00f29b99eaf6d6019c8b0cda0.png";